// src/components/Shared/PromptDialog.js

import React, { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField } from '@mui/material';

import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
    dialogPaper: {
        borderRadius: 4,
        minWidth: 400
    },
    title: {
        fontWeight: 600,
        color: '#2b3a47'
    }
}));

const PromptDialog = ({
    open,
    onClose,
    onConfirm,
    title = 'Ingrese un valor',
    label,
    defaultValue = '',
    confirmText = 'Aceptar',
    cancelText = 'Cancelar'
}) => {
    const classes = useStyles();
    const [value, setValue] = useState(defaultValue);

    useEffect(() => {
        if (open) {
            setValue(defaultValue);
        }
    }, [open, defaultValue]);

    const handleConfirm = () => {
        if (value.trim()) {
            onConfirm(value.trim());
            onClose();
        }
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleConfirm();
        }
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            classes={{ paper: classes.dialogPaper }}
        >
            <DialogTitle className={classes.title}>
                {title}
            </DialogTitle>
            <DialogContent>
                <TextField
                    fullWidth
                    label={label}
                    value={value}
                    onChange={(e) => setValue(e.target.value)}
                    onKeyPress={handleKeyPress}
                    autoFocus
                    margin="dense"
                />
            </DialogContent>
            <DialogActions style={{ padding: 16 }}>
                <Button onClick={onClose} variant="outlined">
                    {cancelText}
                </Button>
                <Button
                    onClick={handleConfirm}
                    variant="contained"
                    color="primary"
                    disabled={!value.trim()}
                >
                    {confirmText}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default PromptDialog;